// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_container__ihQVK {
  width: 90%;
  height: 100%;
  top: 100px;
}

.Form_wrapper__2huY\\+ {
  background-color: #f7f7f7;
  border-radius: 16px;
  padding: 50px;
  width: 60%;
  margin-left: 20%;
  margin-bottom: 50px;
}
.Form_form__vs-Q7 {
  display: flex;
  flex-direction: column;
  padding: 0px 60px;
}

.Form_formDiv__kxFnn {
  display: flex;
  gap: 50px;
}

.Form_left__7HdSh,
.Form_right__cVk6o {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
}

.Form_right__cVk6o .Form_input__vaw3o {
  width: 100%;
}

.Form_right__cVk6o .Form_textarea__nfVHO {
  width: 95%;
}

.Form_h1__UY4n0,
.Form_h2__D94b7 {
  font-family: "Lato";
  font-weight: 800;
  font-size: 36px;
}

.Form_label__n2FLN {
  font-size: 16px;
  font-weight: 700;
  font-family: "Open Sans";
  color: #090446;
  margin: 10px 0;
}

.Form_input__vaw3o,
.Form_textarea__nfVHO {
  font-size: 16px;
  font-weight: 400;
  font-family: "Open Sans";
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 20px;
  color: #747474;
}

.Form_btns__D9Wwx {
  width: 100%;
  display: flex;
  gap: 20px;
}

.Form_button1__uvSG5,
.Form_ok__3Whwq,
.Form_button2__D67LW {
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
}
.Form_button1__uvSG5,
.Form_ok__3Whwq {
  background-color: #47a9f4;
}

.Form_button2__D67LW {
  background-color: #e6eaed;
  color: #5f6d7e;
}

.Form_btnText1__6B5u2,
.Form_btnText2__99E0q {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.Form_btnText1__6B5u2 {
  color: #ffffff;
}

.Form_btnText2__99E0q {
  color: #5f6d7e;
}

.Form_button1__uvSG5:hover,
.Form_button2__D67LW:hover {
  cursor: pointer;
}

.Form_textarea__nfVHO {
  min-height: 100px;
  resize: vertical;
}

.Form_input__vaw3o:focus,
.Form_textarea__nfVHO:focus {
  border: 1px solid #47a9f4;
  outline: none;
}

.Form_success__2BjK4 {
  /* padding-top: 100px; */
  height: 200px;
  width: 200px;
}

.Form_content__iyjgK {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
}

.Form_h1__UY4n0 {
  padding-left: 60px;
}

.Form_h2__D94b7,
.Form_p__G9y39 {
  text-align: center;
}

.Form_p__G9y39 {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  color: #090446;
}

.Form_ok__3Whwq {
  width: 90%;
  margin-left: 5%;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 700;
  color: white;
}

@media screen and (max-width: 1300px) {
  .Form_formDiv__kxFnn,
  .Form_btns__D9Wwx {
    flex-direction: column;
  }
  .Form_left__7HdSh,
  .Form_right__cVk6o {
    width: 100%;
  }
  .Form_wrapper__2huY\\+ {
    width: 80%;
    margin-left: 10%;
  }
}
@media screen and (max-width: 680px) {
  .Form_wrapper__2huY\\+ {
    position: relative;
    padding: 50px 0;
    width: 116%;
    left: -55px;
    border-radius: 0;
  }
  .Form_h1__UY4n0 {
    font-size: 34px;
  }
}

@media screen and (max-width: 600px) {
  .Form_h1__UY4n0 {
    font-size: 32px;
    width: 70%;
  }
  .Form_wrapper__2huY\\+ {
    width: 117%;
    left: -50px;
  }
}

@media screen and (max-width: 550px) {
  .Form_wrapper__2huY\\+ {
    left: -45px;
  }
}

@media screen and (max-width: 500px) {
  .Form_wrapper__2huY\\+ {
    left: -40px;
  }
}

@media screen and (max-width: 450px) {
  .Form_h1__UY4n0,
  .Form_form__vs-Q7 {
    padding: 0 30px;
  }
  .Form_wrapper__2huY\\+ {
    left: -36px;
  }
}

@media screen and (max-width: 426px) {
  .Form_wrapper__2huY\\+ {
    left: -32px;
    width: 118%;
  }
}

@media screen and (max-width: 376px) {
  .Form_h1__UY4n0,
  .Form_form__vs-Q7 {
    padding: 0 35px;
  }
  .Form_wrapper__2huY\\+ {
    left: -29px;
    width: 119%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Form.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;;IAEE,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;EACb;AACF","sourcesContent":[".container {\n  width: 90%;\n  height: 100%;\n  top: 100px;\n}\n\n.wrapper {\n  background-color: #f7f7f7;\n  border-radius: 16px;\n  padding: 50px;\n  width: 60%;\n  margin-left: 20%;\n  margin-bottom: 50px;\n}\n.form {\n  display: flex;\n  flex-direction: column;\n  padding: 0px 60px;\n}\n\n.formDiv {\n  display: flex;\n  gap: 50px;\n}\n\n.left,\n.right {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 50%;\n}\n\n.right .input {\n  width: 100%;\n}\n\n.right .textarea {\n  width: 95%;\n}\n\n.h1,\n.h2 {\n  font-family: \"Lato\";\n  font-weight: 800;\n  font-size: 36px;\n}\n\n.label {\n  font-size: 16px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n  color: #090446;\n  margin: 10px 0;\n}\n\n.input,\n.textarea {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Open Sans\";\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  padding: 8px;\n  margin-bottom: 20px;\n  color: #747474;\n}\n\n.btns {\n  width: 100%;\n  display: flex;\n  gap: 20px;\n}\n\n.button1,\n.ok,\n.button2 {\n  padding: 16px 24px 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  width: 100%;\n  margin-top: 20px;\n}\n.button1,\n.ok {\n  background-color: #47a9f4;\n}\n\n.button2 {\n  background-color: #e6eaed;\n  color: #5f6d7e;\n}\n\n.btnText1,\n.btnText2 {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.btnText1 {\n  color: #ffffff;\n}\n\n.btnText2 {\n  color: #5f6d7e;\n}\n\n.button1:hover,\n.button2:hover {\n  cursor: pointer;\n}\n\n.textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.input:focus,\n.textarea:focus {\n  border: 1px solid #47a9f4;\n  outline: none;\n}\n\n.success {\n  /* padding-top: 100px; */\n  height: 200px;\n  width: 200px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 50px 0;\n}\n\n.h1 {\n  padding-left: 60px;\n}\n\n.h2,\n.p {\n  text-align: center;\n}\n\n.p {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 400;\n  color: #090446;\n}\n\n.ok {\n  width: 90%;\n  margin-left: 5%;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n}\n\n@media screen and (max-width: 1300px) {\n  .formDiv,\n  .btns {\n    flex-direction: column;\n  }\n  .left,\n  .right {\n    width: 100%;\n  }\n  .wrapper {\n    width: 80%;\n    margin-left: 10%;\n  }\n}\n@media screen and (max-width: 680px) {\n  .wrapper {\n    position: relative;\n    padding: 50px 0;\n    width: 116%;\n    left: -55px;\n    border-radius: 0;\n  }\n  .h1 {\n    font-size: 34px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .h1 {\n    font-size: 32px;\n    width: 70%;\n  }\n  .wrapper {\n    width: 117%;\n    left: -50px;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .wrapper {\n    left: -45px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .wrapper {\n    left: -40px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .h1,\n  .form {\n    padding: 0 30px;\n  }\n  .wrapper {\n    left: -36px;\n  }\n}\n\n@media screen and (max-width: 426px) {\n  .wrapper {\n    left: -32px;\n    width: 118%;\n  }\n}\n\n@media screen and (max-width: 376px) {\n  .h1,\n  .form {\n    padding: 0 35px;\n  }\n  .wrapper {\n    left: -29px;\n    width: 119%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Form_container__ihQVK`,
	"wrapper": `Form_wrapper__2huY+`,
	"form": `Form_form__vs-Q7`,
	"formDiv": `Form_formDiv__kxFnn`,
	"left": `Form_left__7HdSh`,
	"right": `Form_right__cVk6o`,
	"input": `Form_input__vaw3o`,
	"textarea": `Form_textarea__nfVHO`,
	"h1": `Form_h1__UY4n0`,
	"h2": `Form_h2__D94b7`,
	"label": `Form_label__n2FLN`,
	"btns": `Form_btns__D9Wwx`,
	"button1": `Form_button1__uvSG5`,
	"ok": `Form_ok__3Whwq`,
	"button2": `Form_button2__D67LW`,
	"btnText1": `Form_btnText1__6B5u2`,
	"btnText2": `Form_btnText2__99E0q`,
	"success": `Form_success__2BjK4`,
	"content": `Form_content__iyjgK`,
	"p": `Form_p__G9y39`
};
export default ___CSS_LOADER_EXPORT___;
